export const USER_LOGIN = "USER_LOGIN";
export const USER_LOGOUT = "USER_LOGOUT";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAILED = "USER_LOGIN_FAILED";
export const USER_LOGOUT_SUCCESS = "USER_LOGOUT_SUCCESS";
export const USER_LOGOUT_FAILED = "USER_LOGOUT_FAILED"
export const GET_USER_DETAILS = "GET_USER_DETAILS";

export const SET_LOADER = "SET_LOADER";
export const UPDATE_LOADER = "UPDATE_LOADER";

export const GET_ANALYTICS_DATA = "GET_ANALYTICS_DATA";
export const GET_ANALYTICS_DATA_SUCCESS = "GET_ANALYTICS_DATA_SUCCESS";
export const GET_ANALYTICS_DATA_FAILED = "GET_ANALYTICS_DATA_FAILED";

export const GET_ANALYTICS_DATA_EVN = "GET_ANALYTICS_DATA_EVN";
export const GET_ANALYTICS_DATA_SUCCESS_EVN = "GET_ANALYTICS_DATA_SUCCESS_EVN";
export const GET_ANALYTICS_DATA_FAILED_EVN = "GET_ANALYTICS_DATA_FAILED_EVN";

export const GET_ANALYTICS_UNANSWERED_DATA = "GET_ANALYTICS_UNANSWERED_DATA";
export const GET_ANALYTICS_UNANSWERED_DATA_SUCCESS = "GET_ANALYTICS_UNANSWERED_DATA_SUCCESS";
export const GET_ANALYTICS_UNANSWERED_DATA_FAILED = "GET_ANALYTICS_UNANSWERED_DATA_FAILED";

export const GET_ANALYTICS_CALL_BREAK_DOWN_DATA = "GET_ANALYTICS_CALL_BREAK_DOWN_DATA";
export const GET_ANALYTICS_CALL_BREAK_DOWN_DATA_SUCCESS = "GET_ANALYTICS_CALL_BREAK_DOWN_DATA_SUCCESS";
export const GET_ANALYTICS_CALL_BREAK_DOWN_DATA_FAILED = "GET_ANALYTICS_CALL_BREAK_DOWN_DATA_FAILED";

export const GET_ANALYTICS_CALL_OVERVIEW_DATA = "GET_ANALYTICS_CALL_OVERVIEW_DATA";
export const GET_ANALYTICS_CALL_OVERVIEW_DATA_SUCCESS = "GET_ANALYTICS_CALL_OVERVIEW_DATA_SUCCESS";
export const GET_ANALYTICS_CALL_OVERVIEW_DATA_FAILED = "GET_ANALYTICS_CALL_OVERVIEW_DATA_FAILED";

export const GET_ANALYTICS_CALL_BREAK_DOWN_DATA_INC = "GET_ANALYTICS_CALL_BREAK_DOWN_DATA_INC";
export const GET_ANALYTICS_CALL_BREAK_DOWN_DATA_INC_SUCCESS = "GET_ANALYTICS_CALL_BREAK_DOWN_DATA_INC_SUCCESS";
export const GET_ANALYTICS_CALL_BREAK_DOWN_DATA_INC_FAILED = "GET_ANALYTICS_CALL_BREAK_DOWN_DATA_INC_FAILED";

export const PUT_EDIT_ANALYTICS_DATA = "PUT_EDIT_ANALYTICS_DATA";
export const PUT_EDIT_ANALYTICS_DATA_SUCCESS = "PUT_EDIT_ANALYTICS_DATA_SUCCESS";
export const PUT_EDIT_ANALYTICS_DATA_FAILED = "PUT_EDIT_ANALYTICS_DATA_FAILED";

export const GET_TRANSCRIPTS_DATA = "GET_TRANSCRIPTS_DATA";
export const GET_TRANSCRIPTS_DATA_SUCCESS = "GET_TRANSCRIPTS_DATA_SUCCESS";
export const GET_TRANSCRIPTS_DATA_FAILED = "GET_TRANSCRIPTS_DATA_FAILED";

export const PUT_EDIT_TRANSCRIPTS_DATA = "PUT_EDIT_TRANSCRIPTS_DATA";
export const PUT_EDIT_TRANSCRIPTS_DATA_SUCCESS = "PUT_EDIT_TRANSCRIPTS_DATA_SUCCESS";
export const PUT_EDIT_TRANSCRIPTS_DATA_FAILED = "PUT_EDIT_TRANSCRIPTS_DATA_FAILED";

export const GET_ANALYTICS_DATA_INC = "GET_ANALYTICS_DATA_INC";
export const GET_ANALYTICS_DATA_INC_SUCCESS = "GET_ANALYTICS_DATA_INC_SUCCESS";
export const GET_ANALYTICS_DATA_INC_FAILED = "GET_ANALYTICS_DATA_INC_FAILED";

export const OPEN_MODAL = "OPEN_MODAL";
export const OPEN_UPDATE_MODAL = "OPEN_UPDATE_MODAL";
export const CLOSE_MODAL = "CLOSE_MODAL";
export const CLOSE_UPDATE_MODAL = "CLOSE_UPDATE_MODAL";

export const PUT_CSV_FILE_IN_BLOB = "PUT_CSV_FILE_IN_BLOB";
export const PUT_CSV_FILE_IN_BLOB_SUCCESS = "PUT_CSV_FILE_IN_BLOB_SUCCESS"
export const PUT_CSV_FILE_IN_BLOB_FAILED = "PUT_CSV_FILE_IN_BLOB_FAILED"

export const POST_OTP_TO_USER = "POST_OTP_TO_USER"
export const POST_OTP_TO_USER_SUCCESS = "POST_OTP_TO_USER_SUCCESS"
export const POST_OTP_TO_USER_FAILED = "POST_OTP_TO_USER_FAILED"

export const VERIFY_OTP_WITH_USER = "VERIFY_OTP_WITH_USER"
export const VERIFY_OTP_WITH_USER_SUCCESS = "VERIFY_OTP_WITH_USER_SUCCESS"
export const VERIFY_OTP_WITH_USER_FAILED = "VERIFY_OTP_WITH_USER_FAILED"

export const CLOSE_OTP_MODAL = "CLOSE_OTP_MODAL"
export const CLOSE_OTP_MODAL_SUCCESS = "CLOSE_OTP_MODAL_SUCCESS"

export const GET_FILES_DATA = "GET_FILES_DATA"
export const GET_FILES_DATA_SUCCESS = "GET_FILES_DATA_SUCCESS"
export const GET_FILES_DATA_FAILED = "GET_FILES_DATA_FAILED"

export const UPDATE_SCHEDULE_CALL_TIME = "UPDATE_SCHEDULE_CALL_TIME"
export const UPDATE_SCHEDULE_CALL_TIME_SUCCESS = "UPDATE_SCHEDULE_CALL_TIME_SUCCESS"
export const UPDATE_SCHEDULE_CALL_TIME_FAILED = "UPDATE_SCHEDULE_CALL_TIME_FAILED"

export const UPDATE_STOP_CALL = "UPDATE_STOP_CALL"
export const UPDATE_STOP_CALL_SUCCESS = "UPDATE_STOP_CALL_SUCCESS"
export const UPDATE_STOP_CALL_FAILED = "UPDATE_STOP_CALL_FAILED"

export const DISABLE_FILE = "DISABLE_FILE"
export const DISABLE_FILE_SUCCESS = "DISABLE_FILE_SUCCESS"
export const DISABLE_FILE_FAILED = "DISABLE_FILE_FAILED"

export const SET_MODAL_STOP_CALL = "SET_MODAL_STOP_CALL"
export const SET_MODAL_STOP_CALL_SUCCESS = "SET_MODAL_STOP_CALL_SUCCESS"


export const DOWNLOAD_BLOB_FILE = "DOWNLOAD_BLOB_FILE"

export const STOP_CURRENT_CALL = "STOP_CURRENT_CALL"
export const STOP_CURRENT_CALL_SUCCESS = "STOP_CURRENT_CALL_SUCCESS"
export const STOP_CURRENT_CALL_FAILED = "STOP_CURRENT_CALL_FAILED"

export const FETCH_GLOBAL_CONFIG = "FETCH_GLOBAL_CONFIG"
export const FETCH_GLOBAL_CONFIG_SUCCESS = "FETCH_GLOBAL_CONFIG_SUCCESS"
export const FETCH_GLOBAL_CONFIG_FAILED = "FETCH_GLOBAL_CONFIG_FAILED"
export const UPDATE_GLOBAL_CONFIG = "UPDATE_GLOBAL_CONFIG"
export const UPDATE_GLOBAL_CONFIG_SUCCESS = "UPDATE_GLOBAL_CONFIG_SUCCESS"
export const UPDATE_GLOBAL_CONFIG_FAILED = "UPDATE_GLOBAL_CONFIG_FAILED"
